import { useState } from 'react';
import FormTemplate, { THEMES } from '@/components/formTemplate/index';
import { SHIPPING_ADDRESS } from '@/constants/shippingAddress';
import Address from '@/containers/address';
import ShippingAddressView from '@/containers/shippingAddressView';

function ShippingAddressClient({
  control,
  title = '',
  unregister,
  resetField,
  getValues,
  defaultAddress,
  deliveryText,
  setValue,
}) {
  const [editingData, setEditingData] = useState(!defaultAddress?.fullAddress);
  const handleEdit = async () => {
    setEditingData(true);
  };
  const returnToDefaultAddress = () => {
    setEditingData(false);
  };

  return (
    <>
      {!editingData && (
        <div className="shipping-address">
          <FormTemplate titleText={title} cyData={SHIPPING_ADDRESS.ID} theme={THEMES.LONG}>
            <ShippingAddressView
              addressInfo={defaultAddress?.fullAddress}
              deliveryText={deliveryText}
              edit={handleEdit}
            />
          </FormTemplate>
        </div>
      )}
      {editingData && (
        <Address
          className="address-container-wrapper"
          unregister={unregister}
          control={control}
          getValues={getValues}
          resetField={resetField}
          componentName={SHIPPING_ADDRESS.ID}
          formStructure={SHIPPING_ADDRESS}
          setInfo={false}
          showTitle={!title}
          showReturnLink={defaultAddress?.fullAddress || false}
          showAddressNotFoundLink={false}
          returnToDefaultAddress={returnToDefaultAddress}
          setValue={setValue}
        />
      )}
      <style jsx>
        {`
          :global(.checkbox-container) {
            padding-bottom: 12px;
          }
        `}
      </style>
    </>
  );
}

export default ShippingAddressClient;
